import { createSlice } from '@reduxjs/toolkit';
import { persistedActions } from '../actions';
import { extLocalStore } from 'util/localStorage';
import { cacheKey } from 'appConstants';

const initialState = {
	sendMethod: extLocalStore.getItem(cacheKey.SEND_METHOD) || 'enter'
};

const persistedSlice = createSlice({
	name: 'persisted',
	initialState,
	reducers: {},
	extraReducers: {
		[persistedActions.setSendMethod]: (state, action) => {
			state.sendMethod = action.payload;
		}
	}
});

export default persistedSlice;
